<template>
    <div class="components-container" style="margin:0; padding: 0 10px;">
        <el-form class="small-space" :model="auditForm" ref="auditForm" label-position="left" label-width="80px">
            <el-form-item label="学生意见" prop="jcCzxmc">
                <el-input type="textarea" :rows="4" v-model="auditForm.opinion" placeholder="请填写学生意见" maxlength="500" show-word-limit>
                </el-input>
            </el-form-item>
        </el-form>
        <div style="width:100%; text-align:center;">
            <el-button style="width: 70px;" type="success" :loading="formSubmiting" @click="audit('1')">同 意</el-button>
            <el-button style="margin-left: 10px;" type="danger" :loading="formSubmiting" @click="audit('2')">不同意</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg } from "utils/message";

    export default {
        props: ['itemCode','relatedCode','auditLevel'],
        data() {
            return {
                formSubmiting: false,
                auditForm: {
                    itemCode: '', //审核项编号
                    relatedCode: '', //相关编号（审核内容的主键）
                    auditLevel: '', //审核层级
                    auditState: '', //审核状态
                    opinion: '', //审核意见
                },
            };
        },
        mounted() {
            this.auditForm.itemCode = this.itemCode;
            this.auditForm.relatedCode = this.relatedCode;
            this.auditForm.auditLevel = this.auditLevel;
        },
        methods: {
            audit(type){
                this.formSubmiting = true;
                this.auditForm.auditState = type;

                this.$api.courseAdjust.courseAdjust.monitorConfirm({
                    data: this.auditForm,
                }).then((response) => {
                    let state = response.data.data.state;

                    if (state == 'Success') {
                        this.$notify({
                            title: "成功",
                            message: "保存成功",
                            type: "success",
                            duration: 1500,
                        });

                        this.auditCallback();
                    }else{
                        this.$notify({
                            title: "失败",
                            message: "保存失败",
                            type: "error",
                            duration: 3000,
                        });
                    }
                }).catch((error) => {
                    this.$notify({
                        title: "错误",
                        message: error,
                        type: "error",
                        duration: 3000,
                    });
                });

                this.formSubmiting = false;
            },
            auditCallback() {
                this.$emit("auditCallback", this.auditForm);
            },
        },
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// monitorAudit.vue?e2778794